import { IClientGridRow } from '@/Interfaces/Client.interface';
import { useAppDispatch } from '@/store/hooks';
import { setSelectedClient } from '@/store/slices/clients.slice';
import { Link } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';

const ClientNameCell = ({ value, row }: GridRenderCellParams<IClientGridRow>) => {
  const dispatch = useAppDispatch();

  const selectRow = useCallback(() => {
    if (!row) return;
    dispatch(setSelectedClient(row));
  }, [dispatch, row]);

  return (
    <div className='overflow-hidden'>
      <Link
        component='button'
        underline='hover'
        sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
        onClick={selectRow}
      >
        {value}
      </Link>
    </div>
  );
};

export default ClientNameCell;
